export default __webpack_public_path__ + "static/media/640_portfolio02-jp-web.c5163f99.png";